import { messageBus as MessageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';

/**
 * @desc Trigger MessageBus event to `show` page level preloader.
 * @example
 * import * as pageLevelPreloader from 'modules/page-level-preloader';
 * pageLevelPreloader.show();
 */
export const show = ( payload = {} ) => {
    MessageBus.trigger( MESSAGE_BUS_EVENTS.SHOW_PAGE_LEVEL_PRELOADER, payload );
};

/**
 * @desc Trigger MessageBus event to `hide` page level preloader.
 * @example
 * import * as pageLevelPreloader from 'modules/page-level-preloader';
 * pageLevelPreloader.hide();
 */
export const hide = () => {
    MessageBus.trigger( MESSAGE_BUS_EVENTS.HIDE_PAGE_LEVEL_PRELOADER );
};
